const VIDEO_FORMAT = {
  mp4: 'mp4',
  webm: 'webm',
}

const VIDEO_RESOLUTION = {
  '240p': {
    width: 426,
    height: 240,
  },
  '360p': {
    width: 640,
    height: 360,
  },
  '480p': {
    width: 854,
    height: 480,
  },
  '720p': {
    width: 1280,
    height: 720,
  },
  '1080p': {
    width: 1920,
    height: 1080,
  },
}

export default function useVideoUrl({
  id,
  format = VIDEO_FORMAT.mp4,
  resolution = VIDEO_RESOLUTION['1080p'],
}: {
  id?: string
  format?: string
  resolution?: {
    width: number
    height: number
  }
}) {
  if (!id) {
    return undefined
  }

  format = format.toLowerCase()

  const { videoCdnUrl } = useRuntimeConfig().public
  const { width, height } = resolution

  return {
    thumbnail: `${videoCdnUrl}/video/${id}/thumbnail.jpg`,
    source: `${videoCdnUrl}/video/${id}/${width}x${height}.${format}`,
    width: width,
    height: height,
  }
}
